import React, { useState } from 'react';
import { X } from 'lucide-react';

const AddEquipmentModal = ({ onClose, styles }) => {
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    nextService: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`bg-white ${styles.rounded} ${styles.shadow} w-full max-w-md p-6`}>
        <div className="flex justify-between items-center mb-4">
          {/* Modal title - uses cardTitleWeight/Size/Color */}
          <h2 className={`${styles.cardTitleSize || 'text-xl'} ${styles.cardTitleWeight || styles.fontWeight} ${styles.cardTitleColor || 'text-gray-900'} ${styles.tracking || ''}`}>
            Add Equipment
          </h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded transition"
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            {/* Form label - uses labelWeight/Size/Color */}
            <label className={`block ${styles.labelSize || styles.fontSize} ${styles.labelWeight || styles.fontWeight} ${styles.labelColor || 'text-gray-700'} mb-2`}>
              Equipment Name
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className={`w-full px-3 py-2 border ${styles.borderColor} ${styles.rounded} ${styles.bodyTextSize || styles.fontSize} ${styles.bodyTextColor || 'text-gray-900'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
              placeholder="e.g., Liferaft #1"
            />
          </div>

          <div>
            <label className={`block ${styles.labelSize || styles.fontSize} ${styles.labelWeight || styles.fontWeight} ${styles.labelColor || 'text-gray-700'} mb-2`}>
              Equipment Type
            </label>
            <select
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              className={`w-full px-3 py-2 border ${styles.borderColor} ${styles.rounded} ${styles.bodyTextSize || styles.fontSize} ${styles.bodyTextColor || 'text-gray-900'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
            >
              <option value="">Select type...</option>
              <option value="LSA">Life-Saving Appliance (LSA)</option>
              <option value="FFE">Fire Fighting Equipment (FFE)</option>
              <option value="NAV">Navigation Equipment (NAV)</option>
              <option value="COMM">Communication Equipment (COMM)</option>
            </select>
          </div>

          <div>
            <label className={`block ${styles.labelSize || styles.fontSize} ${styles.labelWeight || styles.fontWeight} ${styles.labelColor || 'text-gray-700'} mb-2`}>
              Next Service Date
            </label>
            <input
              type="date"
              value={formData.nextService}
              onChange={(e) => setFormData({ ...formData, nextService: e.target.value })}
              className={`w-full px-3 py-2 border ${styles.borderColor} ${styles.rounded} ${styles.bodyTextSize || styles.fontSize} ${styles.bodyTextColor || 'text-gray-900'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
            />
          </div>

          <div className="flex gap-3 mt-6">
            {/* Button text - uses buttonTextWeight/Size */}
            <button
              type="button"
              onClick={onClose}
              className={`flex-1 px-4 py-2 border ${styles.borderColor} ${styles.rounded} ${styles.buttonTextWeight || styles.fontWeight} ${styles.buttonTextSize || styles.fontSize} ${styles.bodyTextColor || 'text-gray-700'} hover:bg-gray-50 transition`}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`flex-1 px-4 py-2 bg-blue-600 text-white ${styles.rounded} ${styles.buttonTextWeight || styles.fontWeight} ${styles.buttonTextSize || styles.fontSize} hover:bg-blue-700 transition`}
            >
              Save Equipment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEquipmentModal;
